import { Base64 } from "js-base64";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../../components/AppProvider";
import HeaderNavigate from "../../../components/UI/Header/HeaderNavigate";
import { PostApi154 } from "../../../modules/network/padoPost";
import { _O } from "../../../modules/utils";
import { checkNum10 } from "../../../modules/utils/CheckLogic";
import { getCookie } from "../../../modules/utils/cookie";
import { CheveronUpCircleSrc, IC } from "../../../resources/Assets";
import { UserInfoList } from "./UserInfoList";

export const AccountMerge = () => {
  const { phonecfg, cfg, userinfo } = useContext(AppContext);
  const [getIdList, setGetIdList] = useState();

  const getMyAccount = () => {
    PostApi154(
      phonecfg,
      cfg,
      userinfo.userName,
      userinfo.userPhone,
      userinfo.birth,
      userinfo.sex,
      getCookie("userDI"),
      userinfo.userToken,
      userinfo.isForeigner
    )
      .then(res => {
        if (res.joinInfo.length > 0) {
          setGetIdList(res.joinInfo);
        } else {
          alert("통합할 계정이 없습니다.");
          window.history.back();
        }
      })
      .catch(err => {
        console.log("getMyAccount:: ", err);
      });
  };

  const getRecentDate = () => {
    const date = new Date();

    return (
      date.getFullYear() +
      "." +
      checkNum10(date.getMonth() + 1) +
      "." +
      checkNum10(date.getDate())
    );
  };

  const setTrgtUserToken = () => {
    let returnData;

    getIdList.map((data, idx) => {
      if (idx == 0) {
        returnData = data.userToken;
      } else {
        returnData += ", " + data.userToken;
      }
    });

    // return returnData;
    _O.Open("/membership/phoneCerti/" + Base64.encode(returnData));
  };

  useEffect(() => {
    getMyAccount();
  }, []);

  return (
    <ContainerWhite>
      {/* <Header /> */}
      <HeaderNavigate
        leftIcon={{
          imgSrc: IC.etc.ICON_CHEVRON_LEFT,
          action: () => window.history.back(),
        }}
        headerTitle="내 정보 수정"
      />
      <div style={{ width: "100vw", padding: "40px 20px" }}>
        <Title>계정통합</Title>
        <TextArea>
          <TextP>현재 로그인한 계정으로 통합되며 통합 후 다른 계정은</TextP>
          <TextP>사용이 불가합니다</TextP>
        </TextArea>

        <ListContainer>
          <ContentsTitle>현재 로그인 계정</ContentsTitle>
          <UserInfoList
            idx={0}
            data={{
              signUpChannel: getCookie("signUpChannel"),
              userId: getCookie("userId"),
              userPhone: userinfo.userPhone,
              recentDate: getRecentDate(),
            }}
          />

          <ImageDiv>
            <img
              src={CheveronUpCircleSrc}
              style={{ width: "24px", height: "24px" }}
            />
          </ImageDiv>

          <ContentsTitle>통합되는 계정</ContentsTitle>
          <div style={{ overflow: "auto", height: "32vh" }}>
            {getIdList &&
              getIdList.map((data, idx) => (
                <UserInfoList idx={idx + 1} data={data} />
              ))}
          </div>
        </ListContainer>
      </div>

      {/* <BottomBtn onClick={() => _O.Open("/membership/certi")}>계정 통합</BottomBtn> */}
      <BottomBtn onClick={() => setTrgtUserToken()}>확인</BottomBtn>
    </ContainerWhite>
  );
};

export const ContainerWhite = styled.div`
  background: white;
  display: flex;
  flex-wrap: wrap;
`;

export const Title = styled.div`
  /* margin: 37px 27px 0px 27px; */
  color: #000;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const TextArea = styled.div`
  /* margin: 16px 27px 0px 27px; */
  margin-top: 8px;
  display: flex;
  flex-flow: column;
  gap: 5px;
`;

export const TextP = styled.div`
  color: #898989;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  word-break: keep-all;
`;

export const ListContainer = styled.div`
  /* margin: 40px 15px 0px 15px; */
  margin-top: 32px;
`;

export const BottomBtn = styled.div`
  display: flex;
  /* height: 52px; */
  /* justify-content: center; */
  /* align-items: center; */
  /* gap: 7px; */
  align-self: stretch;

  height: 54px;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  background-color: #6b65de;

  /* border-radius: 6px;
  border: 1px solid #333;
  background: #333; */

  color: #fff;
  font-family: Malgun Gothic;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  margin: 0 20px;
  bottom: 24px;
  position: absolute;
  width: calc(100% - 40px);
`;

const ContentsTitle = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  margin-bottom: 8px;
`;

const ImageDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding-bottom: 16px;
`;
